export default __webpack_public_path__ + "static/14-28288b8feb043e74ae0335472b58a23a.jpg";